import React, { useEffect, useState, ChangeEvent } from 'react';
import { useWizardFormContext } from 'providers/WizardFormProvider';
import { Form } from 'react-bootstrap';
import { WizardFormData } from 'components/forms/CampaignWizardForm';
import {
  fetchBXPMediaResourceGroups,
  fetchBXPGreetings,
  BXPMediaResourceGroup,
  BXPGreeting
} from 'services/hvaservicecampaign.service';

const WizardCampaignAdvForm: React.FC = () => {
  // eslint-disable-next-line
  const { formData, onChange, validation } = useWizardFormContext<WizardFormData>();
  const [mediaGroups, setMediaGroups] = useState<BXPMediaResourceGroup[]>([]);
  const [greetings, setGreetings] = useState<BXPGreeting[]>([]);

  useEffect(() => {
    const loadOptions = async () => {
      try {
        const [mediaGroupsData, greetingsData] = await Promise.all([
          fetchBXPMediaResourceGroups(),
          fetchBXPGreetings()
        ]);
        setMediaGroups(mediaGroupsData);
        setGreetings(greetingsData);
      } catch (error) {
        console.error('Error loading form options:', error);
      }
    };

    loadOptions();
  }, []);

  const handleMediaGroupChange = (e: ChangeEvent<HTMLElement>) => {
    const target = e.target as HTMLSelectElement;
    const selectedId = Number(target.value);
    const selectedGroup = mediaGroups.find(group => group.id === selectedId);
    onChange({
      target: {
        name: 'mediagroup',
        // eslint-disable-next-line
        value: selectedGroup ? { id: selectedId, shortname: selectedGroup.shortname } : { id: 0, shortname: '' }
      }
      // eslint-disable-next-line
    } as any);
  };

  const handleGreetingChange = (e: ChangeEvent<HTMLElement>) => {
    const target = e.target as HTMLSelectElement;
    const selectedId = Number(target.value);
    // eslint-disable-next-line
    const selectedGreeting = greetings.find(greeting => greeting.id === selectedId);
    onChange({
      target: {
        name: 'greeting',
        // eslint-disable-next-line
        value: selectedGreeting ? { id: selectedId, shortname: selectedGreeting.shortname } : { id: 0, shortname: '' }
      }
      // eslint-disable-next-line
    } as any);
  };

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    // eslint-disable-next-line
    onChange(e as React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>);
  };

  return (
    <>
      <Form.Group className="mb-3">
        <Form.Label>Media Resource Group</Form.Label>
        <Form.Control
          as="select"
          name="mediagroup"
          value={formData.mediagroup?.id || ''}
          onChange={handleMediaGroupChange}
          required={validation}
        >
          <option value="">...</option>
          {mediaGroups.map(group => (
            <option key={group.id} value={group.id}>
              {group.shortname}
            </option>
          ))}
        </Form.Control>
        <Form.Control.Feedback type="invalid">
          Media Resource Group is required.
        </Form.Control.Feedback>
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Check
          type="switch"
          id="callrecording"
          label="Recording of calls"
          name="callrecording"
          checked={formData.callrecording === true}
          onChange={handleCheckboxChange}
        />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Greeting</Form.Label>
        <Form.Control
          as="select"
          name="greeting"
          value={formData.greeting?.id || ''}
          onChange={handleGreetingChange}
          required={validation}
        >
          <option value="">...</option>
          {greetings.map(greeting => (
            <option key={greeting.id} value={greeting.id}>
              {greeting.shortname}
            </option>
          ))}
        </Form.Control>
        <Form.Control.Feedback type="invalid">
          Greeting is required.
        </Form.Control.Feedback>
      </Form.Group>
      <Form.Group>
        <Form.Label>Routing DN</Form.Label>
        <Form.Control
          type="text"
          name="routingdn"
          placeholder="Enter Routing DN"
          value={formData.routingdn || ''}
          onChange={onChange}
          required={validation}
          maxLength={32}
        />
        <Form.Control.Feedback type="invalid">
          Routing DN is required.
        </Form.Control.Feedback>
      </Form.Group>
    </>
  );
};

export default WizardCampaignAdvForm;
